import { getRecordState } from '@/utils/games/blackjack2';
import { HandInfo } from './HandInfo';
import { CardInfo, HandSeats, getNewBetHands } from './SeatCardInfo';
import { BetSeatIndex } from './SeatPlayerInfo';
import { PairResult } from './enums/WinState';

export type GameInfo = {
    game_id: string;
    game_count: number;
    count_down: number;
    remain_time: number;
    state: number;
    sub_state: number;
    action_seat: number;
    seats_info: Array<SeatInfo>;
    dealer: HandInfo;
    // seat0: SeatInfo;
    // seat1: SeatInfo;
    // seat2: SeatInfo;
    // seat3: SeatInfo;
    // seat4: SeatInfo;
    // seat5: SeatInfo;
    // seat6: SeatInfo;
    // seat7: SeatInfo;
};
export type OldResultInfo = ResultInfo & {
    gameid: string;
};
export type ResultInfo = {
    winset: Array<number>;
    dealer: HandInfo;
    seats_info: Array<SeatInfo>;
    surrender: Array<number>;
};
//server data format
type SeatPlayerInfo = {
    seat_num: number; //
    player_id: number; //
    bet_amt: number; //
    allow_decision: Array<number>; //
    consecutive_wins: number; //
    predecision: number;
};

type SeatCardInfo = {
    // hand1: HandInfo; //
    // hand2: HandInfo; //
    h1: HandInfo; //
    h2: HandInfo; //
};
type SeatIconInfo = {
    is_split: number;
    pair_result: PairResult;
    // is_insurance: boolean;
    // is_surrender: boolean;
};

export type SeatInfo = SeatCardInfo & SeatIconInfo & SeatPlayerInfo;

export const convertToCardInfo = (
    info: HandInfo,
    allow_decision: Array<number>
): CardInfo => {
    return {
        cards: info.c,
        display_txt: info.cp,
        allow_decision: allow_decision,
        last_decision: info.a,
        result: info.r,
        recordState: getRecordState(info.r, info.cp),
    };
};
type BJ2Info = {
    infos: HandSeats;
    others: GameInfo;
};
export const convertBJ2Hands = (resultStr: string, hostId: number): BJ2Info => {
    let json = {} as GameInfo;
    try {
        json = JSON.parse(resultStr) as GameInfo;
        console.log(json);
    } catch (e) {
        console.error(e);
    }
    let hands = getNewBetHands(hostId);
    hands.Dealer = convertToCardInfo(json.dealer, []);
    hands.GameState = json.state;
    hands.ActionSeat = json.action_seat;
    hands.ActionHand = json.sub_state;
    for (let i = 0; i < json.seats_info.length; i++) {
        let tmp = json.seats_info[i];
        let key = `Seat${tmp.seat_num}` as BetSeatIndex;
        hands[key] = {
            isSplit: tmp.is_split == 1,
            hand1: convertToCardInfo(tmp.h1, tmp.allow_decision),
            hand2: convertToCardInfo(tmp.h2, tmp.allow_decision),
        };
    }

    return { infos: hands, others: json };
};
